export const ONBOARDING_TABLE_CLASS_NAME = 'onboardingFingoTable';
export const DEFAULT_TABLE_CLASS_NAME = 'defaultFingoTable';
export const ONBOARDING_LAST_TABLE_CELL_CLASS_NAME = 'last-table-cell-onboarding';
export const DETAILED_FINGO_TABLE_CLASS_NAME = 'detailedFingoTable';
